/*
 * Functions for Spinners
 * Hopefully a replacement of static_src/c2Archive/js/block.js
 */

(function (c2) {

  'use strict';

  const hideClassName = "d-none";
  const showClassName = "d-block";
  const spinner = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';

  function showSpinner({selector='#content', block=false, useImage=true, fade=false, button=false} = {}) {
    const spinnerTemplate = document.getElementById(fade ? 'spinner-block' : 'spinner-template')
    const imageTemplate = document.getElementById(useImage ? 'spinner-image':'spinner-circle');
    const spinnerCopy = spinnerTemplate.content.firstElementChild.cloneNode(true);
    const spinnerImageCopy = imageTemplate.content.firstElementChild.cloneNode(true);
    if (block) {
      spinnerCopy.classList.add('w-100', 'align-items-center', 'position-absolute', 'z-3', 'spinner-block')
    } else if (!useImage) {
      spinnerCopy.classList.add('d-block','mt-3')
    } else if (selector === '#content') {
      spinnerCopy.classList.add('position-fixed', 'vw-100', 'vh-100')
    } else {
      spinnerCopy.classList.add(showClassName)
    }
    spinnerCopy.querySelector('#portal-spinner').appendChild(spinnerImageCopy)
    if (fade) {
      $(spinnerCopy).appendTo($(selector))
    } else if (button) {
       // Adding disabled property too early will prevent button submission`
       $(spinner).appendTo($(selector))
    } else if (block || selector === '#content') {
      $(spinnerCopy).prependTo($(selector))
    } else {
      $(selector).html(spinnerCopy)
    }
  }

  function showInlineSpinner({element} = {}) {
    if ($(element).find('.spinner-box-inline').length) {
      return;
    }

    const spinnerTemplate = document.getElementById('spinner-line')
    const spinnerCopy = spinnerTemplate.content.firstElementChild.cloneNode(true);

    $(spinnerCopy).appendTo(element)
  }

  function hideSpinner({selector='#content', fade=false, button=false, block=false} = {}) {
    if (fade) {
      if ($(selector).find('.blocker-fade')) {
        $(selector).find('.blocker-fade').remove();
      }
    } else if (button) {
      $(selector).find('.spinner-border').remove()
    } else if (block) {
      $(selector).find('.spinner-block').remove()
    } else {
      $(selector).empty()
    }
  }

  function hideInlineSpinner({element} = {}) {
    if (element && element.jquery) {
      element.find('.spinner-box-inline').remove()
    } else if (element && element.nodeType) {
      element.querySelector('.spinner-box-inline').remove()
    }
  }

  c2.spinners = {
    hideSpinner: hideSpinner,
    showSpinner: showSpinner,
    showInlineSpinner: showInlineSpinner,
    hideInlineSpinner: hideInlineSpinner,
    spinner: spinner
  };

})(window.c2);
